import styled, { css } from 'styled-components';
import { FlexCenterAligned, FlexibleDiv } from '../../../../../styled/common';
import { Typography } from '../../../../ui/Typography';

export const LabelText = styled(Typography)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${({ theme }) => theme.colors.systemColors.blue};
    `}
`;

export const LeasedTabLabel = styled(FlexCenterAligned)<{ isActive: boolean }>`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  height: 48px;

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${({ theme }) => theme.colors.background.tertiary};
    `}
`;

export const LeasedTab = styled(FlexibleDiv)`
  width: 50%;

  &:first-child ${LeasedTabLabel} {
    border-radius: 14px 0 0 14px;
    border-right: none;
  }

  &:last-child ${LeasedTabLabel} {
    border-radius: 0 14px 14px 0;
  }

  &:hover {
    ${LabelText} {
      color: ${({ theme }) => theme.colors.systemColors.blue};
    }
  }
`;

export const optionWrapperStyles = css`
  gap: 0;
  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: 416px;
  }
`;
